export default __webpack_public_path__ + "f1f3400711003c84fdd9238a925d2ea8.svg";